import {
  callPeerName,
  callPeerNumber,
  useSoftphone
} from "@dialstack/sdk-react/softphone";

import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { displayNumber } from "../call-display.util";
import {
  consultBarButtonSx,
  consultBarSx,
  workbenchOverlayLabelSx
} from "./dialstack-softphone-widget.styles";
import useColleagueLookup, {
  colleagueLabel
} from "./use-colleague-lookup.hook";

// An attended transfer in progress: the caller is parked, the colleague is on
// the consult leg. Complete hands the caller over; Cancel drops the consult
// and brings the caller back. Replaces the SDK's consult banner, which lived
// inside its in-call screen (ENG-2226).
export default function ConsultTransferBar() {
  const { consultCall, completeAttendedTransfer, cancelAttendedTransfer } =
    useSoftphone();
  const number = consultCall ? callPeerNumber(consultCall) : null;
  const lookupColleague = useColleagueLookup(number ? [number] : []);
  if (!consultCall || !number) return null;
  const colleague = lookupColleague(number, callPeerName(consultCall));
  const target = colleague ? colleagueLabel(colleague) : displayNumber(number);
  const connected = consultCall.state === "active";
  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={1}
      data-testid="consult-transfer-bar"
      sx={consultBarSx}
    >
      <Typography sx={[workbenchOverlayLabelSx, { flex: 1, minWidth: 0 }]}>
        {connected ? `Consulting ${target}` : `Calling ${target}…`}
      </Typography>
      <Button
        size="small"
        variant="outlined"
        className="suno-phone-no-drag"
        onClick={cancelAttendedTransfer}
        sx={consultBarButtonSx}
      >
        Cancel
      </Button>
      <Button
        size="small"
        variant="contained"
        className="suno-phone-no-drag"
        onClick={completeAttendedTransfer}
        disabled={!connected}
        sx={consultBarButtonSx}
      >
        Complete transfer
      </Button>
    </Stack>
  );
}
